<template>
  <section>
    <div class="fshr-tripCard__date">
      <i class="fshr-tripCard__icon icon-kalendar" />
      <span class="fshr-tripCard__dateLabel" v-if="dateRange">
        {{ dateRange }}
      </span>
      <span class="fshr-tripCard__dateCaption" v-if="datePostfix">
        ({{ datePostfix }})
      </span>
    </div>
  </section>
</template>

<script>
import { format, getDay } from "date-fns";

const days = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];

export default {
  name: "Date-range-slot",

  props: {
    range: {
      type: Object,
      require: true,
      validator(value) {
        if (value.to && value.from) {
          return new Date(value.to) && new Date(value.from);
        }

        return false;
      },
    },
    translations: {
      default() {
        return {
          sun: "sun",
          mon: "mon",
          tue: "tue",
          wed: "wed",
          thu: "thu",
          fri: "fri",
          sat: "sat",
        };
      },
    },
  },

  data() {
    const { range } = this;
    const from = new Date(range.from);
    const to = new Date(range.to);

    return {
      dateRange: `${format(from, "dd.MM.")} - ${format(to, "dd.MM. yy")}`,
      datePostfix: `${this.getTranslation(
        days[getDay(from)]
      )} - ${this.getTranslation(days[getDay(to)])}`,
    };
  },
};
</script>
